import { classNames } from '@zambezi/sdk/common'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { useMenu } from './menu'

/**
 * Create a Nav Sub Menu component
 *
 * @param {import('./interfaces').NavSubMenuProps} props
 * @param {import('react').Ref} ref
 * @returns {JSX.Element}
 */
function navSubMenu ({ className, isOpen, ...props }, ref) {
  const { content } = useMenu(
    {
      ...props,
      isOpen,
      className: classNames(
        {
          'zb-nav-submenu': true,
          'zb-nav-submenu-is-open': isOpen
        },
        className
      )
    },
    ref
  )
  return content
}
const NavSubMenu = forwardRef(navSubMenu)

NavSubMenu.displayName = 'NavSubMenu'
NavSubMenu.componentName = 'zb.NavSubMenu'

NavSubMenu.propTypes = {
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  onItemKeyDown: PropTypes.func,
  onItemSelect: PropTypes.func
}

NavSubMenu.defaultProps = {
  isOpen: false
}

export default NavSubMenu
